import {
  Card,
  CardContent,
  Typography,
  CardActions
} from "@mui/material";
import "@emotion/react";
import "@emotion/styled";

export default function StoryCard({
  time = "sometime",
  title = "sometitle",
  content = "somecontent"
}) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Typography gutterBottom sx={{ color: "text.secondary", fontSize: 14 }}>
          {time}
        </Typography>
        <Typography variant="h5" component="div">
          {title}
        </Typography>
        <Typography variant="body2">{content}</Typography>
      </CardContent>
      <CardActions>
        {/* Button is disabled until "Projects" page will be implemented */}
        {/* <Button size="medium">Read more</Button> */}
      </CardActions>
    </Card>
  );
}
